import React, { useState } from "react";
import Select from "react-select";
import { useCreateTopUpMutation } from "../../apis/TopUPApi";
import { getUserData } from "../../auth";
 
const SelectorComponent = ({ items, onItemSelected }) => {
  const [amount, setAmount] = useState("");
  const [selectedItem, setSelectedItem] = useState(null); // Track selected item
  const [isLoadingCreate, setIsLoadingCreate] = useState(false); // Track loading state

  const userData = getUserData();
  const userId = userData?.uid || "";
  // RTK Query mutation hook for modifying the wallet request
  const [requestWallet,{isSuccess}] = useCreateTopUpMutation();

  // Transform items into options for react-select
  const options = items.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  // Handle selection change
  const handleSelectChange = (selectedOption) => {
    const selectedItem = items.find((item) => item.id === selectedOption.value);
    setSelectedItem(selectedItem); // Store selected item locally
    onItemSelected(selectedItem); // Pass the selected item to the parent
  };

  // Handle amount input change
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  // Handle submit (using RTK Query mutation to modify the wallet request)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingCreate(true); // Set loading state to true when submitting

    // Create wallet request object to send
    const walletRequest = {
      amountRequested: parseFloat(amount) || 0, // Ensure amount is a valid number
      date: new Date().toISOString(), // Use current date for the request
      status: "PENDING", 
      validateDateTime: "", // Example date, replace with actual logic if needed
    };

    try {
      // Call the RTK Query mutation to modify the wallet request
 await requestWallet({
    topUp: walletRequest, // Pass the walletRequest data
    payment_id: selectedItem?.id, // Assuming this is how the ID should be passed
    user_id: userId, // Assuming userId is the ID of the user
  }).unwrap();
  
    //  console.log("Request sent successfully:", walletRequest);
    } catch (error) {
      console.error("Failed to modify wallet request:", error);
    } finally {
      setIsLoadingCreate(false); // Reset loading state after request is finished
    }
  };

  return (
    <>
      <div className="col-xl-6 pe-xl-5">
        <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
          <form onSubmit={handleSubmit}>
            {/* Select Dropdown */}
            <div className="mb-24">
              <h6>Select Payment Method</h6>
              <Select
                options={options}
                onChange={handleSelectChange}
                placeholder="Select an item"
                isClearable
                menuPlacement="top"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    position: 'absolute', // Adjusting the dropdown position
                    bottom: '100%', // To ensure it opens above the input
                  }),
                }}
              />
            </div>

            {/* Wallet Amount Input */}
            <div className="mb-24">
              <input
                type="number"
                className="common-input"
                placeholder="Enter amount"
                value={amount}
                onChange={handleAmountChange}
              />
            </div>

            {/* Submit Button */}
            <div className="mt-24">
              <button
                type="submit"
                className="btn btn-main py-18 px-32 rounded-8"
                disabled={isLoadingCreate} // Disable button when loading
              >
                {isLoadingCreate ? 'Requesting...' : 'Request wallet'}
              </button>
    {/* Show success message */}
    {isSuccess && <p className="text-green-500 mt-4">Request well Processed!, you can see all request in topUp Requested</p>}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SelectorComponent;
